module.exports = __webpack_public_path__ + "img/10_no.b1925130.svg";